import { toast } from 'react-hot-toast';
import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { XMarkIcon } from '@heroicons/react/24/solid';

const Notify = (type, message, duration = 2000) => {
  const iconSize = 'h-6 w-6';
  const icons = {
    success: <CheckCircleIcon className={`${iconSize} text-green-600`} />,
    error: <XCircleIcon className={`${iconSize} text-red-600`} />,
    warning: <ExclamationTriangleIcon className={`${iconSize} text-yellow-600`} />,
  };
  const toastMessage = (
    <div className={`flex items-center gap-4 p-4 rounded-lg shadow border bg-white text-sm ${type === 'success' ? 'text-green-800' : type === 'error' ? 'text-red-800' : 'text-yellow-800'}`}>
      <div className={`flex items-center justify-center p-1.5 rounded-lg ${type === 'success' ? 'bg-green-200' : type === 'error' ? 'bg-red-200' : 'bg-yellow-200'}`}>
        {icons[type]}
      </div>
      <div className="leading-none">{message}</div>
      <button onClick={() => toast.dismiss()} className="text-gray-500 hover:text-gray-700 focus:outline-none">
        <XMarkIcon className="h-5 w-5" />
      </button>
    </div>
  );
  toast(toastMessage, {
    duration: duration,
    position: 'top-center',
    style: { background: 'transparent', boxShadow: 'none' },
  });
};

export default Notify;
